<div class="logs-signpost-default">
    <ng-content></ng-content>

    <div
        class="logs-signpost-default__wrapper"
        *ngIf="logsSignpostStore.logSelectedSignpostConfigKey$ | async as configKey"
    >
        <logs-signpost-default-header
            [configKey]="configKey"
        ></logs-signpost-default-header>

        <logs-signpost-default-view-log-list
            [configKey]="configKey"
        ></logs-signpost-default-view-log-list>
    </div>
</div>
